'use es6';

import SpamThreadAlert from './SpamThreadAlert';
import { provideThreadView } from '../../thread-view/decorators/provideThreadView';
export default provideThreadView(SpamThreadAlert);